import { alpha, Box, Card, Paper, Stack, Typography, useTheme } from '@mui/material';

const statLabels = ['Today', 'Week', 'Month', 'All time'];

const StatCard = ({ icon, name, values, currency, horizontal }) => {
    const theme = useTheme();
    return (
        <Card
            elevation={0}
            sx={{
                py: 1.9,
                px: 2.5,
                color: theme.palette.primary.main,
                border: '1px solid rgba(255,255,255,0.1)',
            }}>
            <Stack direction="row" justifyContent={'space-between'} alignItems="center">
                <Stack direction="row" alignItems="center" spacing={1}>
                    {!horizontal && (
                        <Box
                            sx={{
                                borderRadius: 9999,
                                height: '40px',
                                width: '40px',
                                border: `1px solid ${theme.palette.primary.main}`,
                                bgcolor: alpha(theme.palette.primary.main, 0.25),
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                            {icon}
                        </Box>
                    )}

                    <Typography color={theme.palette.text.primary} fontSize={15} fontWeight={600}>
                        {name}
                    </Typography>
                </Stack>
            </Stack>

            <Stack direction={horizontal ? 'row' : 'column'} gap={2} mt={2}>
                {statLabels.map((label, i) => (
                    <Box sx={{ fontWeight: 600, width: '100%' }}>
                        <Paper
                            sx={{
                                py: 0.5,
                                px: 1,
                            }}>
                            {label.toUpperCase()}
                        </Paper>
                        <Typography mt={1} sx={{ color: '#fff' }} variant="h4" fontWeight={600}>
                            {currency ? '$' + (values[i] || 0).toFixed(2) : values[i] || 0}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </Card>
    );
};

export default StatCard;
